const AGE_GATE_INPUTS = {
    MONTH: 'month',
    YEAR: 'year',
} as const;

export default AGE_GATE_INPUTS;
